var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ThirdStep',{attrs:{"id":"modal-step-content"},on:{"addActivityProduct":_vm.addActivityProduct}})
}
var staticRenderFns = []

export { render, staticRenderFns }